import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export interface DueItem {
  id: number;
  consumer: string;
  consumerType: string;
  service: string;
  totalDue: number;
  dueDays: number;
}

interface DueAnalysisTableProps {
  data: DueItem[];
}

const DueAnalysisTable = ({ data }: DueAnalysisTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Consumer</TableHead>
          <TableHead>Type</TableHead>
          <TableHead>Service</TableHead>
          <TableHead className="text-right">Due Amount</TableHead>
          <TableHead className="text-center">Days Overdue</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((item) => (
          <TableRow key={item.id}>
            <TableCell>{item.consumer}</TableCell>
            <TableCell>{item.consumerType}</TableCell>
            <TableCell>{item.service}</TableCell>
            <TableCell className="text-right">
              ${item.totalDue.toLocaleString()}
            </TableCell>
            <TableCell className="text-center">{item.dueDays}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default DueAnalysisTable;
